module.exports = ".pricing-list-container {\n\n}\n.pricing-list-container .pricing-list-caption {\n    margin-bottom: 15px;\n}\n.pricing-list-container .price-list-types {\n\n}\n.pricing-list-container .price-list-types .button {\n    width: 200px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/agora/components/pricing-data/pricing-list/pricing-list.component.css
// module id = ./src/app/agora/components/pricing-data/pricing-list/pricing-list.component.css
// module chunks = main